import { Header } from "../../models/Header";
import { acheteur, division, ordre, section } from "./columns";

export const sectionHeaders: Header[] = [
  {
    ...division,
    field: "division.div_nom",
  },
  {
    ...section,
    isDisplayed: true,
    isAddOnly: false,
  },
  ordre,
  acheteur,
];
